import { Connection as ConnectionData, IO } from '@interfaces/connection'
import collect, { Collection } from 'collect.js'
import { Pawn } from '@/services/store/types'

export default class ModelConnection {
  private data: ConnectionData

  constructor(data: ConnectionData) {
    this.data = data
  }

  get fromID(): string {
    return this.data.fromID
  }

  get toID(): string | null {
    return this.data.toID
  }

  get inputs(): Collection<IO> {
    return collect(this.data.inputs)
  }

  get outputs(): Collection<IO> {
    return collect(this.data.outputs)
  }

  get chainlengthModifier(): number {
    return this.data.chainlengthModifier
  }

  public isInvalid(pawn: Pawn) {
    if (this.fromID === '1oxv7zxd' &&
      this.toID === '123687xm' &&
      pawn.chainLengths.length > 0 &&
      pawn.chainLengths[0] >= 16) {
      return true
    }

    if (this.fromID === 'rd956yxe' &&
      this.toID === 'm430kwxr' &&
      pawn.chainLengths[0] === 2) {
      return true
    }

    return false
  }
}
